/**
 *@ngdoc directive
 *@name cbl.finanza.mf.directives.directive:finRicercaStrumento
 *@restrict E
 *@scope
 *@description Direttiva utilizzata per effettuare la ricerca dello strumento finanziario
 *@apram {Function} callback - Funzione richiamata dopo aver selezionato il titolo in tabella
 */
(function(window, undefined) {
	"use strict";
	angular.module("cbl.finanza.mf.directives").directive("finRicercaStrumento", ['FIN_CONSTANTS', function(CONSTANTS) {
		var link = function (scope, elem, attrs, model) {};

		var controller = function($scope,$rootScope, $q, $http, $stateParams, userSrvc, messaggiFctr, uiGridConstants,$timeout) {
			this.$http = $http;
			this.$stateParams = $stateParams;
			this.messaggiFctr = messaggiFctr;
			this.uiGridConstants = uiGridConstants;
			this.$timeout = $timeout;
			this.userSrvc = userSrvc;
			this.modalitaEsposizioneESG = null;
			this.esposizioneRatingESG = false;
        	this.esposizioneScoreESG = true;
			this.esgConsulenzaAttiva = false;
			this.tipologiaStrumento = [];
			//Doppio slider
			this.lowerSlider = null;
			this.upperSlider = null;
			this.lowerVal = null;
			this.upperVal = null;
			this.sliderMaxValue = null;
			this.sliderMinValue = null;
			this.selectedAll = false;

			this.searchFilters = {
				isin: null,
				descrizione: null,
				categoria: null,
				listaRatingEsg:[],
				listaClassificazioneSfrd:[],
				pai:null,
				tassonomia:null,
				esgA:null,
				esgDa:null
			};

			this.spinner = {
				ricercaStrumento: false,
				recuperaDomini:false
			};
			
			this.dominiEsgStrumento = {
				dominioScoreEsg:null,
				dominioRatingEsg:null,
				dominioClassificazioneSfdr:null,
				dominioPai:null,
				dominioTassonomia:null
			};

			this.sfdrChecklist =null;
			this.ratingEsgCheckList = null;
			this.strumenti = null;
			this.selectedStrumento = null;
			this.validUpperInput = true;
			this.validLowerInput = true;
			var self = this;
			
			/* 
	    	 * -------------------------------------
	    	 * START METODI PROMISE PER SERVIZI REST
	    	 * -------------------------------------
	    	 */
			
			/**
	    	 * @ngdoc method
	    	 * @name promiseRicercaStrumento
	    	 * @methodOf cbl.finanza.mf.directive:finRicercaStrumento
	    	 * @description Effettua la chiamata per la ricerca strumento
			 * @return {Promise} - Ritorna una promise contenente la lista degli strumenti trovati
	    	 */
			this.promiseRicercaStrumento = function() {
				return self.$http({
					method: 'PUT',
					url: CONSTANTS.REST_ROOT + CONSTANTS.REST.STRUMENTO + 'ricercaStrumenti',
					data: {
						parametri: {
							isin: self.searchFilters.isin || null,
							descrizione: self.searchFilters.descrizione || null,
							listaCategorie: {
								categorie: self.searchFilters.categoria ? new Array(self.searchFilters.categoria) : null
							},
							pai:!!self.searchFilters.pai ? self.searchFilters.pai.toString().trim() : null,
							tassonomia: !!self.searchFilters.tassonomia ? self.searchFilters.tassonomia.toString().trim() : null,
							listaClassificazioneSfrd: !!self.searchFilters.listaClassificazioneSfrd ? self.searchFilters.listaClassificazioneSfrd : null,
							scoreEsgA:self.searchFilters.esgA !== null ? parseFloat(self.searchFilters.esgA.toString().replace(',','.')) : null,
							scoreEsgDa:self.searchFilters.esgDa !== null ? parseFloat(self.searchFilters.esgDa.toString().replace(',','.')) : null,
							listaRatingEsg:self.searchFilters.listaRatingEsg
						},
						iniziativa: self.$stateParams.finIniziativa,
						idRaccomandazione: self.$stateParams.finIdRaccomandazione,
					}
				});
			};
			/* 
	    	 * -----------------------------------
	    	 * END METODI PROMISE PER SERVIZI REST
	    	 * -----------------------------------
	    	 */
			
			/* 
	    	 * -----------------------
	    	 * START METODI CONTROLLER
	    	 * -----------------------
	    	 */
			
			/**
			 * @ngdoc method
			 * @name clear
			 * @methodOf cbl.finanza.mf.directives.directive:finRicercaStrumento
			 * @description Svuota i campi della ricerca strumento
			 */
			this.clear = function() {
				self.searchFilters.isin = null;
				self.searchFilters.decrizione = null;
				self.searchFilters.categoria = null;
				self.searchFilters.tassonomia = null;
				self.searchFilters.pai = null;
				self.lowerVal = parseInt(self.sliderMinValue.slice(0,-4));
				self.upperVal = parseInt(self.sliderMaxValue.slice(0,-4));

				self.sliderMaxValue = self.dominiEsgStrumento.dominioScoreEsg !== null ? self.dominiEsgStrumento.dominioScoreEsg.find(function(dominio){return dominio.descrizione === 'MAX'}).codice : 100;
				self.sliderMinValue = self.dominiEsgStrumento.dominioScoreEsg ? self.dominiEsgStrumento.dominioScoreEsg.find(function(dominio){return dominio.descrizione === 'MIN'}).codice : 0;

				self.upperSlider.value = parseInt(self.sliderMaxValue.slice(0,-4));
				self.lowerSlider.value = parseInt(self.sliderMinValue.slice(0,-4));

				if(self.dominiEsgStrumento.dominioClassificazioneSfdr !== null && self.dominiEsgStrumento.dominioRatingEsg !== undefined)
				{self.dominiEsgStrumento.dominioClassificazioneSfdr.forEach(function(dominio) {
					dominio.selected = false
				});}
				if(self.dominiEsgStrumento.dominioRatingEsg !== null && self.dominiEsgStrumento.dominioRatingEsg !== undefined)
				{self.dominiEsgStrumento.dominioRatingEsg.forEach(function(dominio) {
					dominio.selected = false
				});}

				self.selectedAll = false;
				$rootScope.$apply();
			};
			
			/**
			 * @ngdoc method
			 * @name ricercaStrumento
			 * @methodOf cbl.finanza.mf.directives.directive:finRicercaStrumento
			 * @description Effettua la ricerca dello strumento
			 */
			this.ricercaStrumento = function() {
				self.spinner.ricercaStrumento = true;
				self.searchFilters.listaRatingEsg = self.elaboraDominiRatinEsg(self.dominiEsgStrumento.dominioRatingEsg);
				self.searchFilters.listaClassificazioneSfrd = self.elaboraDominiSfdr(self.dominiEsgStrumento.dominioClassificazioneSfdr);
				if(self.lowerVal!== null){
					self.searchFilters.esgDa = self.lowerVal;
				}
				if(self.upperVal !== null){
					self.searchFilters.esgA = self.upperVal;
				}
				self.promiseRicercaStrumento().then(function(response) {
					if (self.messaggiFctr.processaResponse(response)) {
						self.gridOptions.data = [];
						return;
					}
					self.gridOptions.data = response.data.result;
					self.strumenti = response.data.result;
				}, function(reason) {
					self.messaggiFctr.processaResponse(reason);
					self.gridOptions.data = [];
				}).finally(function() {
					self.spinner.ricercaStrumento = false;
				});
			};

			/**
			 * @description Apre la dropdown della classificazione sfdr
			 */
			this.toggleDropDownSfdr = function(){
				if (self.sfdrChecklist.classList.contains('visible'))
					self.sfdrChecklist.classList.remove('visible');
				else self.sfdrChecklist.classList.add('visible');
			};

			/**
			 * @description Apre la dropdown del rating esg
			 */
			this.toggleDropDownRatingEsg = function(){
				if (self.ratingEsgCheckList.classList.contains('visible'))
					self.ratingEsgCheckList.classList.remove('visible');
				else self.ratingEsgCheckList.classList.add('visible');
			};

			/**
			 * @returns NULL
			 * @description Aggiunge i campi selected agli ai domini classificazione sfdr e rating-esg
			 */
			this.elaboraResponse = function(response){
				if(!response){
					return;
				}
				response.dominioClassificazioneSfdr.forEach(function(element) {
					Object.assign(element,{selected:false})
				});
				if(self.esposizioneRatingESG){
					response.dominioRatingEsg.forEach(function(dominio){
						Object.assign(dominio,{selected:false})});
				}
			};
			/**
			 * @description Recupera la modalita di esposizione Esg e inizializza il doppio slider
			 */
			this.recuperaModalitaEsposizioneESG = function() {
				self.lowerSlider = document.querySelector('#lower');
				self.upperSlider = document.querySelector('#upper');

				self.lowerVal = parseInt(self.sliderMinValue);
				self.upperVal = parseInt(self.sliderMaxValue);

				self.upperSlider.oninput = function() {
				self.lowerVal = parseInt(self.lowerSlider.value);
				self.upperVal = parseInt(self.upperSlider.value);
				console.log(self.upperVal);

				if (self.upperVal < self.lowerVal + 1) {
					self.lowerSlider.value = self.upperVal - 1;
				}

				$rootScope.$apply();
				};
		
				self.lowerSlider.oninput = function() {
				self.lowerVal = parseInt(self.lowerSlider.value);
				self.upperVal = parseInt(self.upperSlider.value);
				console.log(self.lowerVal);
				if (self.lowerVal > self.upperVal - 1) {
					self.upperSlider.value = self.lowerVal + 1;	
					}
				$rootScope.$apply();
				};

				self.esgConsulenzaAttiva = userSrvc.abilitato(CONSTANTS.ABILITAZIONI.ESG_CONSULENZA_ATTIVA);
				console.log('Esg consulenza attiva '+ self.esgConsulenzaAttiva);
				self.modalitaEsposizioneESG =
				self.userSrvc.configurazioni[CONSTANTS.ABILITAZIONI.MODALITA_ESPOSIZIONE_ESG_STRUMENTO];
				console.log('Modalita esposizione esg '+ self.modalitaEsposizioneESG);
				
				switch (self.modalitaEsposizioneESG) {
					case 'RATING':
						self.esposizioneRatingESG = true;
						self.esposizioneScoreESG = false;
						break;
					case 'SCORE':
						self.esposizioneRatingESG = false;
						self.esposizioneScoreESG = true;
						break;
					case 'ALL':
						self.esposizioneRatingESG = true;
						self.esposizioneScoreESG = true;
						break;
				}
				// Se il tipo di esposizione esg è rating aggiungo la colonna nella tabella
			if(self.esposizioneRatingESG){

				//TODO:rimettere qunado sarà stabilito con CABEL
				//self.gridOptions.columnDefs.splice(5,0,
					// {
					//  displayName: 'Rating ESG',
					//  field: 'esgStrumento.ratingSintetico',
					//  cellTemplate:'<div class="ui-grid-cell-contents center">'+
					// 	'<span>{{row.entity.esgStrumento.ratingSintetico }}</span>'+
					// 	'<a' +
					// 	'  href="javascript:;"' +
					// 	'  class="dropdown-toggle titolo-menu-cliente ng-scope"' +
					// 	'  data-toggle="dropdown"' +
					// 	'  aria-haspopup="true"' +
					// 	'  aria-expanded="false"' +
					// 	'  ng-if="row.entity.esgStrumento.tipoVisualizzazioneEsg === \'D\' && !!row.entity.esgStrumento.ratingSintetico "' +
					// 	'>' +
					// 	'  <span' +
					// 	'    ><i' +
					// 	'      class="fa fa-info-circle"' +
					// 	'      aria-hidden="true"' +
					// 	'      style="cursor: pointer"' +
					// 	'	   ng-click="grid.appScope.ricercaCtrl.infoRatingClicked($event,rowRenderIndex,row.entity);"'+
					// 	'    ></i' +
					// 	'  ></span>' +
					// 	'</a>' +
					// 	'</div>',
					//  	width: '12%'
					// }
					//)
					self.gridOptions.columnDefs.splice(6,0,{
						displayName: 'Rating ESG',
						field: 'esgStrumento.ratingSintetico',
						cellClass:'right',
						width: '12%',
					});
			}
			//Se il tipo di esposizione esg è score aggiungo la colonna nella tabella
			if(self.esposizioneScoreESG){
				// self.gridOptions.columnDefs.splice(6,0,{
				// displayName: 'Score ESG',
				// field: 'esgStrumento.scoreSintetico',
				// type:'number',
				// cellTemplate:'<div class="ui-grid-cell-contents center">'+
				// 	'<span>{{row.entity.esgStrumento.scoreSintetico | number:2}}</span>'+
				// 	'<a' +
				// 	'  href="javascript:;"' +
				// 	'  class="dropdown-toggle titolo-menu-cliente ng-scope"' +
				// 	'  data-toggle="dropdown"' +
				// 	'  aria-haspopup="true"' +
				// 	'  aria-expanded="false"' +
				// 	'  ng-if="row.entity.esgStrumento.tipoVisualizzazioneEsg === \'D\' && !!row.entity.esgStrumento.scoreSintetico "' +
				// 	'>' +
				// 	'  <span' +
				// 	'    ><i' +
				// 	'      class="fa fa-info-circle"' +
				// 	'      aria-hidden="true"' +
				// 	'      style="cursor: pointer"' +
				// 	'	   ng-click="grid.appScope.ricercaCtrl.infoScoreClicked($event,rowRenderIndex,row.entity);"'+
				// 	'    ></i' +
				// 	'  ></span>' +
				// 	'</a>' +
				// 	'</div>',
				// width: '12%'})
				self.gridOptions.columnDefs.splice(6,0,{
					displayName: 'Score ESG',
					field: 'esgStrumento.scoreSintetico',
					type:'number',
					cellFilter: 'number : 2',
					cellClass:'right',
					width: '12%'})
			}
			};

			/**
			 * @description Filtra le classificazioni sfdr che hanno il campo selected a true e poi rimuove il campo selected
			 * @param {*} classificazioniSfdr
			 */
			this.elaboraDominiSfdr = function(classificazioniSfdr){
				var classificazioniSelezionate = null;
				if(!!classificazioniSfdr){
					classificazioniSelezionate = classificazioniSfdr.filter(function(dominio){
						return dominio.selected
					}).map(function(dominio){
						return dominio.codice
					});
				return classificazioniSelezionate
			}
			}
			/**
			 * @description description Filtra i rating esg che hanno il campo selected a true e poi rimuove il campo selected
			 * @param {*} dominiRatingEsg 
			 */
			this.elaboraDominiRatinEsg = function(dominiRatingEsg){
				var ratingSelezionati = null;
				if(!!dominiRatingEsg){
					 ratingSelezionati = dominiRatingEsg.filter(function(dominio){
						return dominio.selected
					}).map(function(dominio){
						return dominio.codice.trim();
					});
				}
				return ratingSelezionati
			}
			

			/**
			 * @description Seleziona tutte le classificazioni sdfr
			 */
			this.selectAll = function(){
				self.dominiEsgStrumento.dominioClassificazioneSfdr.forEach(function(elements) {
					elements.selected = !!self.selectedAll ? true : false;
				})
			}
			
			/**
			 * 
			 * @param {*} event 
			 * @param {*} index 
			 * @param {*} entity 
			 * @description gestisci il click sull'info-point nella colonna score per poi aprire la infobox
			 */
			this.infoScoreClicked = function(event,index,entity){
				event.stopPropagation();
				self.selectedStrumento = self.strumenti.find(function(elem){
					return elem.isin === entity.isin;
				});

				$('#score_esg_modal').modal('show')
			}

			/**
			 * 
			 * @param {*} event 
			 * @param {*} index 
			 * @param {*} entity 
			 * @description gestisci il click sull'info-point nella colonna rating per poi aprire la infobox
			 */
			this.infoRatingClicked = function(event,index,entity){
				event.stopPropagation();
				self.selectedStrumento = self.strumenti.find(function(elem){
					return elem.isin === entity.isin;
				});

				$('#rating_esg_modal').modal('show')
			}

			/**
			 * 
			 * @param {*} event 
			 * @param {*} input 
			 * @description verifica che i valori passati tramite input nello score ESG siano un numero e sostituisce le virgole con i punti
			 */
			this.convalidaInput = function(event,input){
				event.target.value = event.target.value.replace(',','.');
				
				if(isNaN(event.target.value)){
					if(input === 'upperInput'){
						self.validUpperInput = false;
					}else if (input === 'lowerInput'){
						self.validLowerInput = false;
					}
				}else{
					self.validUpperInput = true;
					self.validLowerInput = true;
				}
			}
			/* 
	    	 * ---------------------
	    	 * END METODI CONTROLLER
	    	 * ---------------------
	    	 */
			
			/*
			 * ----------------------------
			 * START METODI INIT CONTROLLER
			 * ----------------------------
			 */
			$timeout(function(){
				self.recuperaModalitaEsposizioneESG();
			});

			this.$http({
				method:'GET',
				url:CONSTANTS.REST_ROOT+CONSTANTS.REST.STRUMENTO+'dominiEsgStrumento',
			}).then(function(response){
				if (self.messaggiFctr.processaResponse(response)) {
					return;
				}
				//Aggiungo a dominioClassificazioneSfdr il campo selected per usarlo come ngmodel nella checkbox
				self.elaboraResponse(response.data.result);
				self.dominiEsgStrumento = response.data.result;
				self.sfdrChecklist = document.getElementById('list1');
				self.ratingEsgCheckList = document.getElementById('list2');

				self.sliderMaxValue = self.dominiEsgStrumento.dominioScoreEsg !== null ? self.dominiEsgStrumento.dominioScoreEsg.find(function(dominio){return dominio.descrizione === 'MAX'}).codice : 100;
				self.sliderMinValue = self.dominiEsgStrumento.dominioScoreEsg ? self.dominiEsgStrumento.dominioScoreEsg.find(function(dominio){return dominio.descrizione === 'MIN'}).codice : 0;

				document.getElementById("upperInput").value = self.sliderMaxValue.slice(0,-4);
				document.getElementById("lowerInput").value = self.sliderMinValue.slice(0,-4);

				self.searchFilters.esgDa = parseInt(self.sliderMinValue.slice(0,-4));
				self.searchFilters.esgA = parseInt(self.sliderMaxValue.slice(0,-4));

				console.log('max '+self.sliderMaxValue+' min: '+self.sliderMinValue);
			},function(reason) {
				self.messaggiFctr.processaResponse(reason);
			});

			this.$http({
				method : 'GET',
				url: CONSTANTS.REST_ROOT + CONSTANTS.REST.STRUMENTO + 'categoriaStrumenti'
			}).then(function(response) {
				if (self.messaggiFctr.processaResponse(response)) {
					return;
				}
				self.tipologiaStrumento = response.data.result;
			}, function(reason) {
				self.messaggiFctr.processaResponse(reason);
			});

			this.gridOptions = {
				enableSorting: true,
	            enableColumnMenus: false,
	            enableGrouping: false,
	            enableFiltering: false,
	            treeRowHeaderAlwaysVisible: false,
	            paginationPageSizes: [10, 25, 50],
	            paginationPageSize: 10,
	            paginationCurrentPage: 1,
	            multiSelect: false,
	            enableRowHeaderSelection: false,
	            enableRowSelection: true,
	            showGridFooter: false,
	            enableVerticalScrollbar: this.uiGridConstants.scrollbars.NEVER,
	            enableColumnResizing: false,
	            onRegisterApi: function (gridApi) {
	            	gridApi.selection.on.rowSelectionChanged($scope, function (row) {
                        $scope.callback({callbackResult: row.entity});
                    });
	            }
			};
			
			this.gridOptions.columnDefs = [
				{displayName: 'Isin', field: 'isin', width: '12%'},
				{displayName: 'Tipo', field: 'categoriaStrumento.descrizione', width: '10%'},
				{displayName: 'Descrizione', field: 'descrizione', width: '18%'},
				{displayName: 'Prezzo', cellFilter: 'number : 2', cellClass: 'right', field: 'quotazioneUltimoPrezzoStorico.prezzo', width: '10%'},
				{displayName: 'Quantita\' minima', cellFilter: self.userSrvc.doppiaPrecisioneQuantita ? 'number : 6' : 'number : 3', cellClass: 'right', field: 'qtaMinimaTrattabile', width: '10%'},
				{displayName: 'Divisa', field: 'divisa', width: '10%'},
				{displayName: 'Data Inizio Sottoscrizione', field: 'dataInizioSottoscrizione', cellFilter : 'date: "dd/MM/yyyy"', width: '10%'},
				{displayName: 'Data Fine Sottoscrizione', field: 'dataFineSottoscrizione', cellFilter : 'date: "dd/MM/yyyy"', width: '10%'},
				{displayName: 'Quantita disponibile', cellFilter: self.userSrvc.doppiaPrecisioneQuantita ? 'number : 6' : 'number : 3', cellClass: 'right', field: 'disponibilita', width: '10%'}
			];
			//Se esgConsulenzaAttiva è true aggiungo queste colonne
			if(!self.esgConsulenzaAttiva){
				self.gridOptions.columnDefs.splice(6,0,{displayName: 'Classificazione SFDR', field: 'esgStrumento.classificazioneSfdr.descrizione', width: '12%'});
				self.gridOptions.columnDefs.splice(7,0,{displayName: 'Considera PAI', field: 'esgStrumento.pai.descrizione', width: '12%'});
				self.gridOptions.columnDefs.splice(8,0,{displayName: 'Allineamento Tassonomia EU', field: 'esgStrumento.tassonomia.descrizione', width: '15%',headerTooltip: 'Allineamento tassonomia EU'});
			}
			
			/*
			 * --------------------------
			 * END METODI INIT CONTROLLER
			 * --------------------------
			 */
		
		};
		controller.$inject = ['$scope','$rootScope', '$q', '$http', '$stateParams', 'FinUserSrvc', 'FinMessaggiFctr', 'uiGridConstants','$timeout'];

		return {
			restrict: "E",
			scope: {
				callback: '&',
				isFromGestioneProposta:'<'
			},
			controller: controller,
			controllerAs: "ricercaCtrl",
			templateUrl: CONSTANTS.BASE_ROOT + "widgets/finRicercaStrumento/finRicercaStrumento.html",
			link: link
		};
	}]);
}(window));


/*****************
 ** WEBPACK FOOTER
 ** ./app/widgets/finRicercaStrumento/finRicercaStrumentoDrct.js
 ** module id = 10
 ** module chunks = 0 1 2
 **/